export default "__VITE_ASSET__v25ykJrV__"